import React from 'react';
import StyledButton from './CurrentPageButton.styles';

var CurrentPageButton = function CurrentPageButton(props) {
  var pageNumber = props.pageNumber,
      text = props.text;
  var ariaLabel = "Page ".concat(text);
  return /*#__PURE__*/React.createElement(StyledButton, {
    pageNumber: pageNumber,
    "aria-label": ariaLabel,
    "aria-current": "true",
    "tab-index": "0"
  }, text);
};

export default CurrentPageButton;